export default __webpack_public_path__ + "static/media/spaceman4.811d55cf.png";